<template>
  <v-snackbar
    id="alert"
    :value="dialogs.alert"
    :color="alert.color || 'success'"
    :timeout="-1"
    content-class="alert"
  >
   <div class="alert-content-wrapper">
     <div>
       {{ alert.message }}
     </div>

     <div class="ml-2">
       <v-btn
        id="alertClose"
        text
        small
        color="white"
        @click="$store.dispatch('main/closeAlert')"
       >
         {{ $t('common.close') }}
       </v-btn>
     </div>
   </div>
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Alert',

  data() {
    return {
      snackbar: true
    }
  },

  computed: {
    ...mapGetters({
      alert: 'main/alert',
      dialogs: 'main/dialogs'
    })
  }
}
</script>

<style>
  .alert-content-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  #alert .v-snack__wrapper {
    display: block;
  }
</style>
